import * as React from 'react';

import { useMutation } from '@apollo/client';
import { useLayer } from '@coursera-web/statsig';

import WarmSessionMutation from 'bundles/search-common/queries/WarmSession.graphql';
import type { WarmSessionMutation as WarmSessionMutationType } from 'bundles/search-common/queries/__generated__/WarmSession';

const AUTOCOMPLETE_PERSONALIZATION_LAYER = 'search-autocomplete';
const ENABLE_WARM_SESSION_PARAM = 'enable_warm_session';

const useWarmSession = (): (() => void) => {
  const isEnabled = useLayer(AUTOCOMPLETE_PERSONALIZATION_LAYER).get(ENABLE_WARM_SESSION_PARAM, false);
  const [warmSession] = useMutation<WarmSessionMutationType>(WarmSessionMutation, {
    context: { clientName: 'gatewayGql' },
  });

  return React.useCallback<() => void>(() => {
    if (!isEnabled) return;
    warmSession().catch(() => {});
  }, [isEnabled, warmSession]);
};

export default useWarmSession;
